import { SliceCaseReducers } from '@reduxjs/toolkit'
import { AwmFundParams, AwmFundResponse } from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<AwmFundResponse>> = {
  payload: {
    data: {
      items: [],
      lastUpdate: '',
    },
    pagination: null,
  },
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: awmFundsDataActions, reducer: awmFundsDataReducer } = createOperationSlice<
  ApiResponse<AwmFundResponse> | null,
  SliceCaseReducers<GenericOperationState<ApiResponse<AwmFundResponse> | null>>,
  AwmFundParams
>({
  name: '@accounts/detail/read/awmFundsData',
  initialState,
  reducers: {},
})
